import { render } from "./HistorytDataIcon.vue?vue&type=template&id=05eadc73"
import script from "./HistorytDataIcon.vue?vue&type=script&lang=js"
export * from "./HistorytDataIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/HistorytDataIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05eadc73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05eadc73', __exports__)) {
    api.reload('05eadc73', __exports__)
  }
  
  module.hot.accept("./HistorytDataIcon.vue?vue&type=template&id=05eadc73", () => {
    api.rerender('05eadc73', render)
  })

}


export default __exports__